import "./Preloader.css";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import PreloaderLogoLight from "../images/preloader-logo-light.svg";
// import PreloaderLogoDark from "../images/preloader-logo-dark.svg";

interface PreloaderProps {
  onComplete: () => void;
}

const BAR_COUNT = 6;

export function Preloader({ onComplete }: PreloaderProps) {
  const preloaderRef = useRef<HTMLDivElement>(null);
  const logoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleLoad = () => {
      if (!preloaderRef.current || !logoRef.current) return;

      const leftHalves = preloaderRef.current.querySelectorAll(
        ".preloader__bar-half--left",
      );
      const rightHalves = preloaderRef.current.querySelectorAll(
        ".preloader__bar-half--right",
      );
      const timeline = gsap.timeline({
        onComplete: () => {
          onComplete();
        },
      });

      // Fade out logo
      timeline.to(logoRef.current, {
        opacity: 0,
        duration: 0.5,
        ease: "power2.inOut",
      });

      // Split bars - left halves go left, right halves go right
      timeline.to(
        leftHalves,
        {
          x: "-100%",
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.inOut",
        },
        "-=0.2",
      );

      timeline.to(
        rightHalves,
        {
          x: "100%",
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.inOut",
        },
        "<",
      );

      // Hide preloader
      timeline.to(preloaderRef.current, {
        opacity: 0,
        duration: 0.3,
        onComplete: () => {
          if (preloaderRef.current) {
            preloaderRef.current.style.display = "none";
          }
        },
      });
    };

    // Wait for all content to load
    if (document.readyState === "complete") {
      // Small delay to ensure smooth experience
      setTimeout(handleLoad, 500);
    } else {
      window.addEventListener("load", () => setTimeout(handleLoad, 500));
    }

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, [onComplete]);

  return (
    <div className="preloader" ref={preloaderRef}>
      <div className="preloader__bars">
        {Array.from({ length: BAR_COUNT }).map((_, index) => (
          <div className="preloader__bar" key={index}>
            <div className="preloader__bar-half preloader__bar-half--left"></div>
            <div className="preloader__bar-half preloader__bar-half--right"></div>
          </div>
        ))}
      </div>
      <div className="preloader__logo" ref={logoRef}>
        <img
          src={PreloaderLogoLight}
          className="preloader__logo-image preloader__logo-image--light"
          alt="Serova logo"
        />
        {/* <img
          src={PreloaderLogoDark}
          className="preloader__logo-image preloader__logo-image--dark"
          alt="Serova logo"
        /> */}
      </div>
    </div>
  );
}
